import { nanoid, customRandom, customAlphabet } from 'nanoid';
import validator from 'validator';

interface DomainInterface {
  isValid(): boolean;
}

export interface QueryOption {
  select?: string[] | string;
  join?: string | null;
  from?: string;
  group?: string;
  max?: any;
  offset?: number;
  limit?: number;
  orderBy?: string;
}

export interface ErrorList {
  [key: string]: any[];
}

class DomainBase implements DomainInterface {
  protected _errors: ErrorList;
  protected _className: string | null;
  constructor() {
    this._errors = {};
    this._className = null;
  }
  get errors() {
    return this._errors;
  }
  beforeValidate() {
    this._errors = {};
  }
  isValid() {
    return Object.keys(this._errors).length === 0;
  }

  toObject() {
    const obj: any = { ...this };
    delete obj._errors;
    delete obj._className;
    return obj;
  }

  static permit(o: any, keys: string[] = []) {
    const obj: any = { ...o };
    const permited: any = {};
    keys.forEach((key) => {
      if (obj[key] !== undefined) permited[key] = obj[key];
    });
    return permited;
  }
}

export class DomainProperty extends DomainBase {
  value: string | null;

  constructor(value: any | null) {
    super();
    this.value = value;
  }

  addError(property: string, content: string) {
    if (!this._errors[property]) {
      this._errors[property] = [];
    }
    this._errors[property].push(content);
  }
}

export class DomainModel extends DomainBase {
  id: number | null;
  createdAt: string | null;
  updatedAt: string | null;

  constructor(props?: any) {
    super();
    if (props) {
      this.id = props.id || null;
      this.createdAt = props.createdAt || null;
      this.updatedAt = props.updatedAt || null;
    } else {
      this.id = null;
      this.createdAt = null;
      this.updatedAt = null;
    }
  }

  addError(property: string, content: string) {
    const modelName = this._className || this.constructor.name;
    if (!this._errors[property]) {
      this._errors[property] = [];
    }
    this._errors[property].push(`model.${modelName}.${property}.${content}`);
  }

  addErrorContent(property: string, content: string) {
    if (!this._errors[property]) {
      this._errors[property] = [];
    }
    this._errors[property].push(content);
  }
}

export function secureRandomString(count: number = 12, customChars?: string) {
  if (customChars) {
    const nanoid = customAlphabet(customChars, count);
    return nanoid();
  } else {
    return nanoid(count);
  }
}

export function isValidUid(uid: string) {
  return (
    uid.match(/[A-Za-z0-9_-]/g)?.length === uid.length &&
    !validator.isNumeric(uid)
  );
}

export function isValidCustomSlug(slug: string) {
  if (slug.includes('/')) {
    return false;
  }
  return (
    slug.match(/[A-Za-z0-9_-]/g)?.length === slug.length &&
    !validator.isNumeric(slug)
  );
}
